import {useTranslation} from "react-i18next";
import {Tab, Tabs} from "@mui/material";
import React, {useEffect} from "react";
import {palette} from "../../technical/style/theme";
import {useTabs} from "./TabsProvider";

export function ContentTabs(props: {
  tabTitleKeys: string[]
}) {
  const {t} = useTranslation();
  const {selectedTab, selectTab} = useTabs()

  useEffect(() => {
    if (selectedTab > props.tabTitleKeys.length - 1) {
      console.debug('Selected tab: ' + selectedTab + ', available tabs: ' + props.tabTitleKeys.length);
      selectTab(0);
    }
  }, [selectedTab, selectTab, props.tabTitleKeys]);

  if (selectedTab > props.tabTitleKeys.length - 1) {
    return <></>
  }

  return (
    <Tabs centered={true} aria-label="tabs" textColor={'primary'} sx={{
      marginLeft: 'auto',
      marginRight: 'auto',
      '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        height: '4px',
        '& > div': {
          maxWidth: 40,
          width: '100%',
          height: '4px',
          borderRadius: '2px',
          backgroundColor: palette.primary,
        },
      }
    }}
          TabIndicatorProps={{children: <div/>}}
          value={selectedTab}
          onChange={(event, value) => {
            selectTab(value);
          }}>
      {props.tabTitleKeys.map((title) =>
        <Tab label={t(title)}
             sx={{
               textTransform: 'none',
               fontSize: '18px',
               fontWeight: 500,
               color: 'text.primary',
             }}
             key={title}/>)}
    </Tabs>
  )
}
